var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesJson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 10.875h12v12h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M15.6 15.778a2.578 2.578 0 01-3.059 2.533l-.352.396a.35.35 0 01-.262.118h-.547v.586a.35.35 0 01-.351.351h-.586v.586a.352.352 0 01-.352.352h-1.64a.351.351 0 01-.352-.352v-1.143c0-.093.037-.183.103-.249l2.37-2.37a2.579 2.579 0 115.027-.808zm-2.578-.703a.703.703 0 101.407 0 .703.703 0 00-1.407 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#FFD044",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.8 5.164c.573 0 .859-.304.859-.912v-1.75h-.563v1.762c0 .157-.029.27-.086.335-.057.067-.154.1-.289.1-.127 0-.261-.018-.401-.053v.431c.09.03.171.052.244.066.072.014.151.02.236.02zm2.134 0c.322 0 .576-.075.761-.223a.742.742 0 00.277-.61.653.653 0 00-.148-.444c-.098-.114-.264-.213-.497-.298l-.277-.102a.948.948 0 01-.287-.142.221.221 0 01-.077-.173c0-.19.148-.285.443-.285.207 0 .432.038.675.113v-.428a1.998 1.998 0 00-.72-.135c-.293 0-.526.07-.7.21a.688.688 0 00-.26.563c0 .182.048.333.146.452.098.119.257.22.48.302l.285.105a.969.969 0 01.294.15c.05.045.074.106.074.183 0 .1-.04.177-.12.231a.61.61 0 01-.342.08c-.115 0-.244-.01-.386-.033a3.2 3.2 0 01-.401-.09v.427c.1.045.22.081.36.107.14.027.28.04.42.04zm2.659 0c.264 0 .493-.057.684-.169a1.09 1.09 0 00.435-.476c.099-.205.148-.445.148-.72 0-.285-.052-.53-.156-.733a1.081 1.081 0 00-.44-.467 1.336 1.336 0 00-.671-.162 1.34 1.34 0 00-.685.167c-.191.112-.336.27-.435.475a1.638 1.638 0 00-.148.72c0 .285.052.53.156.735.103.205.25.361.44.468.19.108.414.162.671.162zm0-.458c-.226 0-.397-.077-.514-.232-.118-.155-.176-.38-.176-.675 0-.295.058-.52.176-.673.117-.154.288-.231.514-.231.224 0 .396.077.513.23.118.154.176.379.176.674 0 .295-.058.52-.176.675-.117.155-.288.232-.513.232zM8.88 5.1V3.296L9.937 5.1h.6V2.501h-.495V4.32L8.986 2.501h-.6V5.1h.495z"
  })))));
}

export default SvgFileTypesJson;